<template>
  <div id="menuList">
    <div class="info1 info2 info3" v-for="(item, index) in list" :key="index">
      <div class="x-line"></div>
      <div class="y-line"></div>
      <div class="title" :class="{ 'update': item.Status == 0, 'error': item.Status == 2 }">
        <span @click="Popups(item.ID)" :title="item.Name">{{ item.Name }}</span>
        <span class="sumCommonality" :class="item.Specificity == 1 ? 'sum1' : 'sum'"
          v-show="item.count > 0">{{ item.count }}</span>
        <div class="zhi" v-if="item.Specificity == 1">直</div>
        <div :class="item.Specificity == 1 ? 'xiala' : 'xiala1'" @click="hidden(index)" v-if="item.children"></div>
        <div></div>
        <span class="msg" v-if="item.check_num > 0">{{ item.check_num }}</span>
      </div>
      <div v-show="hidn[index]">
        <menuList v-if="item.children" :list="item.children"></menuList>
      </div>
    </div>
  </div>
</template>
<script>
import menuList from "./BackmenuList.vue";
export default {
  name: "menuList",
  props: ["list", "sum"],
  data() {
    return {
      hidn: [],
      el: ""
    };
  },
  created() {
    // if(this.list[0].ID){
    //   console.log(this.list[0].ID)
    // }
    // console.log(this.list);
    this.list.forEach(el => {
      this.el = el;
      this.hidn.push(false);
    });
    // console.log(this.sum);
    // }
  },
  mounted() {
    // if (this.list[0]) {
    //   this.list.forEach(el => {
    //     this.el = el;
    //     this.hidn.push(true);
    //     // this.hidn[1]=true
    //   });
    //   // this.hidn.push(true);
    //   // this.hidn[1]=true
    // } else {
    //   this.list.forEach(el => {
    //     this.el = el;
    //     this.hidn.push(false);
    //     // this.hidn[1]=true
    //   });
    // }
  },
  methods: {
    hidden(i) {
      console.log(i);
      this.$axios
        .post(
          "company/company_xj",
          this.$qs.stringify({
            token: sessionStorage.getItem("token"),
            ID: this.list[i].ID
          })
        )
        .then(res => {
          console.log(res.data.data.list);
          if (res.data.code == 10000) {
            this.list[i].children.forEach(val => {
              // console.log(val)
              res.data.data.list.map(val1 => {
                if (val.ID == val1.ID) {
                  // val.count = val1.Counts;
                  this.$set(val, "count", val1.Counts);
                }
              });
            });
            console.log(this.list);
            this.hidn[i] = !this.hidn[i];
            this.hidn = [...this.hidn];
          }
        });
    },
    Popups(a) {
      sessionStorage.setItem("bgcompanyID", a);
      console.log(this.$parent.$el.id)
      if ((this.$parent.$el.id).indexOf('pane') > -1) {
        // console.log(this.$parent.$parent.$parent)
        // 跳出el-tab组件 直接调用最外层方法
        this.$parent.$parent.$parent.Popups(a);
        return
      }
      this.$parent.Popups(a);
      // document.querySelector(".getcompany div").click();
    }
  },
  components: {
    menuList
  }
};
</script>
<style scope lang="less">
// #menuList,.info1{
//   overflow: hidden;
// }

.info1 {
  position: relative;
  //overflow: hidden;
  // border-left: 1px dashed #b8b9bb;
  // height:100%;
  //background:url(../assets/back/line_conn.gif) 0 0 repeat-y;
}

.info1 .title {
  cursor: pointer;
  height: 0.4rem;
  width: 3rem;
  font-size: 0.18rem;
  background: #2d65d2;
  border-radius: 0.04rem;
  color: #fff;
  line-height: 0.4rem;
  text-align: center;
  margin-bottom: 0.18rem;
  overflow: hidden;
  position: relative;
}

.info1 .info2 .x-line {
  height: 1px;
  width: .9rem;
  position: absolute;
  background: #bdbdbd;
  left: -.9rem;
  top: 0.2rem;
}

.info1 .info2 .y-line {
  height: calc(100% + 0.2rem);
  width: 1px;
  position: absolute;
  background: #bdbdbd;
  left: -.9rem;
  top: -0.4rem;
  z-index: -1;
}

.info1 #menuList {
  padding-left: 1.2rem;
}

.info1 .info2>.title {
  width: 3rem;
  background: #57a6f7;
  position: relative;
}

.info1 .info2 .info3>.title {
  width: 4rem;
  font-size: 0.14rem;
  padding: 0 0.2rem;
  background: #ffffff;
  color: #000000;
  border: 1px #bfbfbf solid;
  position: relative;
}

.update {
  background: green !important;
  color: #ffffff !important;
}

.error {
  background: red !important;
  color: #ffffff !important;
}

.zhi {
  width: 0.25rem;
  height: 0.4rem;
  border-radius: 0.2rem 0 0 0.2rem;
  position: absolute;
  top: -0.01rem;
  right: 0rem;
  margin-top: -0.01rem;
  font-size: 0.16rem;
  background: #2d65d2;
  color: #ffffff;
}

.xiala {
  position: absolute;
  width: 0.4rem;
  height: 0.4rem;
  top: -0.01rem;
  right: 0.2rem;
  background: url(../assets/back/下拉f.png) no-repeat center;
}

.xiala1 {
  position: absolute;
  width: 0.4rem;
  height: 0.4rem;
  top: -0.01rem;
  right: -0.03rem;
  background: url(../assets/back/下拉f.png) no-repeat center;
}

.info1 .info2 .info3 .xiala {
  background: url(../assets/back/下拉2.png) no-repeat center;
}

.info1 .info2 .info3 .xiala1 {
  background: url(../assets/back/下拉2.png) no-repeat center;
}

// .title::before{
//   display: table;
//   content: "";
// }

.msg {
  // position: relative;
  // display:inline-block ;
  position: absolute;
  width: 0.3rem;
  height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  border-radius: 50%;
  // position: absolute;
  top: 0.05rem;
  left: 0rem;
  color: #fff;
  background: red;
  // margin:.1rem 0 0 .1rem ;
}

.sumCommonality {
  color: #fff;
  font-size: 0.16rem;
  position: absolute;
  min-width: 0.3rem;
  min-height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  border-radius: 50%;
  background: #2dd29a;
  top: 0.05rem;
}

.sum {
  right: 0.3rem;
}

.sum1 {
  right: 0.5rem;
}
</style>
